import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirstImageUrl } from '../utils/imageUtils';


export default function PropertyCard({ property, onClick }) {
    const imageUrl = getFirstImageUrl(property.fotos);
    const navigate = useNavigate();

    let caracteristicas = {};
    try {
        caracteristicas = JSON.parse(property.caracteristicas || '{}');
        caracteristicas.baños = caracteristicas.baños || caracteristicas.banos;
    } catch (e) {
        console.error('Error parsing caracteristicas', e);
    }

    const tipoInmueble = caracteristicas.inmueble || 'Inmueble';
    const modalidad = caracteristicas?.modalidad?.toUpperCase() || 'Modalidad';


    return (
        <article
            className="property-card"
            onClick={() => {
                if (!property.id_propiedad) {
                    console.error('❌ Property has no valid ID:', property);
                    return;
                }
                navigate(`/propiedad/${property.id_propiedad}`);
            }}
            role="button"
            tabIndex={0}
            aria-label={`Ver detalles de ${property.titulo} - ${modalidad} - $${parseInt(property.precio).toLocaleString()} MXN`}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if (!property.id_propiedad) {
                        console.error('❌ Property has no valid ID:', property);
                        return;
                    }
                    navigate(`/propiedad/${property.id_propiedad}`);
                }
            }}
            style={{
                width: '100%',
                minHeight: '400px',
                maxWidth: '320px',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '16px',
                overflow: 'hidden',
                backgroundColor: 'white',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                cursor: 'pointer',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                margin: '0 auto',
            }}
                onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-4px)';
                    e.target.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
                }}
            >
                <img
                    src={imageUrl}
                    alt={`Imagen de la propiedad: ${property.titulo}`}
                    style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover'
                    }}
                />
                <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', fontSize:'.8rem' }}>
                        {caracteristicas?.modalidad &&(
                            <span 
                                style={{ 
                                    backgroundColor: modalidad === 'venta'|| modalidad=== 'VENTA' ? '#00921E' : modalidad === 'renta' || modalidad=== 'RENTA'? '#1A75BB' : modalidad === 'remate'|| modalidad=== 'REMATE' ? '#B21215' : '#7A7878',
                                    color: 'white', 
                                    padding: '4px 10px', 
                                    borderRadius: '8px', 
                                    fontWeight: 'bold',
                                }}
                                aria-label={`Modalidad: ${modalidad}`}
                            >
                                {modalidad}
                            </span>
                        )}
                        
                         {caracteristicas?.inmueble &&(
                        <span 
                            style={{ backgroundColor: '#08395F', color: 'white', padding: '4px 10px', borderRadius: '8px', fontWeight: 'bold' }}
                            aria-label={`Tipo de inmueble: ${tipoInmueble}`}
                        >
                            {tipoInmueble.toUpperCase()}
                        </span>
                         )}
                    </div>
                    <h3 style={{ margin: '0 0 8px 0', fontSize:'1rem' }}>{property.titulo}</h3>
                   
                    <p style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#00921E', margin: '0 0 12px 0' }}>
                        <span aria-label={`Precio: ${parseInt(property.precio).toLocaleString()} pesos mexicanos`}>
                            ${parseInt(property.precio).toLocaleString()} MXN
                        </span>
                    </p>
                        
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '10px' }} role="list" aria-label="Características de la propiedad">
                        {caracteristicas.cuartos && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }} role="listitem">
                                <img src="/Orsan/cama.png" alt="" style={{ width: '14px', height: '14px', objectFit: 'contain' }} aria-hidden="true" />
                                <span aria-label={`${caracteristicas.cuartos} cuartos`}>{caracteristicas.cuartos}</span>
                            </span>
                        )}
                        {caracteristicas.baños && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }} role="listitem">
                                <img src="/Orsan/Baño.webp" alt="" style={{ width: '14px', height: '14px', objectFit: 'contain' }} aria-hidden="true" />
                                <span aria-label={`${caracteristicas.baños} baños`}>{caracteristicas.baños}</span>
                            </span>
                        )}
                        {caracteristicas.tamaño && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }} role="listitem">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#64748b' }} aria-hidden="true">
                                  <path d="M3 3v18h18V3H3zm16 16H5V5h14v14z"/>
                                  <path d="M6 6h12v12H6z" fill="none" stroke="currentColor" strokeWidth="1"/>
                                  <path d="M9 9h6v6H9z" fill="none" stroke="currentColor" strokeWidth="0.5"/>
                                </svg>
                                <span aria-label={`${caracteristicas.tamaño} metros cuadrados`}>{caracteristicas.tamaño}m²</span>
                            </span>
                        )}
                    </div>
                    
                    <div style={{ color: 'gray', fontSize: '15px' }}>
                        <span aria-label={`Ubicación: ${caracteristicas.ubicacion || 'Sin ubicación especificada'}`}>
                            {caracteristicas.ubicacion || 'Sin ubicación'}
                        </span>
                    </div>
                </div>
            </article>
    );
}